import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

type HapticEvent = 'collectible' | 'dailyStreak' | 'streak' | 'summary';

// Patterns de vibration (ms) utilisés en natif Android et en fallback web
const PATTERNS: Record<HapticEvent, number[]> = {
  collectible: [40, 60, 40, 60, 120],
  dailyStreak: [60, 50, 120],
  streak: [35],
  summary: [30, 40, 60],
};

const isAndroid = () => Capacitor.getPlatform() === 'android';

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Vibration pour les moments de récompense.
 * Android natif : plugin @capacitor/haptics (le navigator.vibrate de la WebView
 * est bloqué sans geste utilisateur). Web : navigator.vibrate si dispo.
 */
export const vibrate = async (event: HapticEvent): Promise<void> => {
  const pattern = PATTERNS[event];
  try {
    if (Capacitor.isNativePlatform()) {
      if (isAndroid()) {
        // Joue le pattern : index pairs = vibration, impairs = pause
        for (let i = 0; i < pattern.length; i++) {
          if (i % 2 === 0) await Haptics.vibrate({ duration: pattern[i] });
          await sleep(pattern[i]);
        }
      } else {
        await Haptics.notification({ type: NotificationType.Success });
        if (event === 'collectible') await Haptics.impact({ style: ImpactStyle.Heavy });
      }
      return;
    }
    if ('vibrate' in navigator) navigator.vibrate(pattern);
  } catch (_) {}
};
